// src/routes.ts
var routes = {
  instance_home: (o) => `/${o.instanceSlug}`,
  organization_adminFull: (o) => `https://admin.loopbound.com/${o.organizationSlug}`,
  organization_settings_home: (o) => `/${o.organizationSlug}`,
  organization_settings_general: (o) => `/${o.organizationSlug}/general`,
  organization_settings_members: (o) => `/${o.organizationSlug}/members`,
  organization_settings_invites: (o) => `/${o.organizationSlug}/invites`,
  organization_settings_workspace: (o) => `/${o.organizationSlug}/workspaces/${o.workspaceSlug}/${o.product}`,
  organization_settings_billing: (o) => `/${o.organizationSlug}/billing`,
  organization_settings_billing_object: (o) => `/${o.organizationSlug}/billing/object/${o.billingObjectId}`,
  organization_support_home: (o) => `/${o.organizationSlug}/support`,
  organization_support_ticket: (o) => `/${o.organizationSlug}/support/tickets/${o.ticketId}`
};
var setRoute = (route, o) => {
  routes[route] = o;
};
var getRoute = (route, opts) => {
  let r = routes[route](opts);
  if (!r.startsWith("/"))
    r = `/${r}`;
  return r;
};

export {
  routes,
  setRoute,
  getRoute
};
//# sourceMappingURL=chunk-7PKRU6HZ.js.map